import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { emptyCriteria } from "../lib/options";

const SearchContext = createContext(null);

const load = (key, fallback) => {
  try {
    const v = sessionStorage.getItem(key);
    return v ? JSON.parse(v) : fallback;
  } catch {
    return fallback;
  }
};

export const SearchProvider = ({ children }) => {
  const [criteria, setCriteriaState] = useState(() => load("atlas_criteria", emptyCriteria()));
  const [compareIds, setCompareIds] = useState(() => load("atlas_compare", []));

  const setCriteria = useCallback((c) => {
    setCriteriaState(c);
    sessionStorage.setItem("atlas_criteria", JSON.stringify(c));
  }, []);

  const toggleCompare = useCallback((id) => {
    setCompareIds((prev) => {
      const next = prev.includes(id)
        ? prev.filter((x) => x !== id)
        : prev.length >= 4 ? prev : [...prev, id];
      sessionStorage.setItem("atlas_compare", JSON.stringify(next));
      return next;
    });
  }, []);

  const clearCompare = useCallback(() => {
    setCompareIds([]);
    sessionStorage.setItem("atlas_compare", JSON.stringify([]));
  }, []);

  const value = useMemo(
    () => ({ criteria, setCriteria, compareIds, toggleCompare, clearCompare }),
    [criteria, setCriteria, compareIds, toggleCompare, clearCompare]
  );

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error("useSearch must be used within SearchProvider");
  return ctx;
};
